import { Form, Select } from 'antd'
import * as PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { useTranslation } from 'react-i18next'

const SelectWithNewOptions = ({
  name,
  rules = [],
  label,
  hasFeedback,
  options,
  allowClear,
  handleSelect,
  setFieldsValue,
  loading,
  autoFocus,
  disabled,
  noStyle,
  size,
                                formName
}) => {
  const [dataSource, setDataSource] = useState(options)
  const [value, setValue] = useState(null)

  useEffect(() => {
    setDataSource(options)
  }, [options])

  const { t } = useTranslation()

  const handleSearchItems = e => {
    const hasMethod = options.find(
      type =>
        type.name?.toLowerCase().includes(e.toLowerCase()) ||
        (typeof type === 'string' && type.toLowerCase().includes(e.toLowerCase()))
    )
    if (hasMethod) {
      setDataSource(options)
    } else if (e && e.trim()) {
      setDataSource([e, ...options])
      setValue(e)
    }
  }

  const onSelect = (e, item) => {
    setValue(e)
    if (handleSelect) {
      handleSelect(item)
      setValue(null)
    }
  }

  const onClear = () => {
    setValue(undefined)
    setFieldsValue({
      [name]: ''
    })
  }

  const onBlur = () => {
    if (value) {
      setFieldsValue({
        [name]: value
      })
    }
  }

  return (
    <Form.Item name={name} rules={rules} label={noStyle ? null : label} hasFeedback={hasFeedback} noStyle={noStyle}>
      <Select
        className="fixArrowSelection"
        showSearch
        optionFilterProp="children"
        filterOption={(input, option) =>
          option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 || option.children === t('patients.addNewItems')
        }
        showAction={['click', isMobile ? '' : 'focus']}
        onSearch={handleSearchItems}
        allowClear={allowClear}
        onSelect={onSelect}
        size={size}
        loading={loading}
        disabled={loading || disabled}
        onClear={onClear}
        onBlur={onBlur}
        autoFocus={autoFocus}
        placeholder={noStyle ? label : null}
        data-testid={`${formName || 'selectWithNewOptions'}-${name}`}
      >
        {dataSource.map((item, i) => (
          <Select.Option key={i.id || i} value={item.id || item}>
            {typeof item === 'string' ? t(item) : `${item.name} - ${item.type || ''} - ${item.strength || ''}`}
          </Select.Option>
        ))}
        <Select.Option key="new" value="newItems" disabled data-testid="selectWithNewOptions-addItemsButton">
          {t('patients.addNewItems')}
        </Select.Option>
      </Select>
    </Form.Item>
  )
}

SelectWithNewOptions.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  rules: PropTypes.array,
  hasFeedback: PropTypes.bool,
  disabled: PropTypes.bool,
  options: PropTypes.array.isRequired,
  allowClear: PropTypes.bool,
  loading: PropTypes.bool,
  handleSelect: PropTypes.func,
  setFieldsValue: PropTypes.func.isRequired
}

export default SelectWithNewOptions
